import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useExperienceRatingApi() {
  const callApi = useApiCall();

  const addExperienceRating = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EXPERIENCE_RATING.ADD, data, onSuccess, onError, true);
  };

  const getExperienceRating = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EXPERIENCE_RATING.GET, data, onSuccess, onError, true);
  };

  const updateExperienceRating = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EXPERIENCE_RATING.UPDATE, data, onSuccess, onError, true);
  };

  return {
    callAddExperienceRating: addExperienceRating,
    callGetExperienceRating: getExperienceRating,
    callUpdateExperienceRating: updateExperienceRating,
  };
}
